import {isInArabicLanguage} from "@/consts/lanuages.js";
import {isInMainLanguage} from "@/consts/lanuages.js";

function conditionsOfVariry(
  value,
  isRtl,
  muiltJsonAndMajorityLangFn,
  muiltJsonAndMinarityLangFn,
  plainAndMajorityLangFn,
  plainAndMinarityLangFn,
){
  if(isMuiltLanguagesJson(value)){
    if(isRtl){
      muiltJsonAndMinarityLangFn()
    }else{
      muiltJsonAndMajorityLangFn()
    }
  }else{
    if(isRtl){
      plainAndMinarityLangFn()
    }else{
      plainAndMajorityLangFn()
    }
  }
}



export function getValueOfMuiltLanguagesJson(value,languageId = mm.store.state.currentLanguage){
  var res
  if(isMuiltLanguagesJson(value)){
    if(value.hasOwnProperty(languageId)){
      res = value[languageId]
    }else{
      res = value.default
    }
  }else{
    res = value
  }

  return res
}


export function getValueOfMuiltLanguagesJson2(value, isRtl){
  var res
  conditionsOfVariry(value, isRtl,
      ()=>{
        res = value['default']
      },
      ()=>{
        if(value.hasOwnProperty('rtl')){
          res = value['rtl']
        }else{
          res = value['default']
        }
      }, ()=>{
        res = value
      }, ()=>{
        res = value
      }
  )
  return res
}

export function setValueOfMuiltLanguagesJson2(value,isRtl, val){
  conditionsOfVariry(value, isRtl,
    ()=>{
      value['default'] = val
    },
    ()=>{
      value['rtl'] = val
    }, ()=>{
      value = val
    }, ()=>{
      value = createMuiltLanguagesJson(value)
      value['rtl'] = val
    }
  )
  return value
}


export function setValueOfMuiltLanguagesJson(value,languageId, val){
  if(!isMuiltLanguagesJson(value)){
    value = createMuiltLanguagesJson(value)
  }


  if(isInMainLanguage(languageId)){
    value['default'] = val
  }else{
    value[languageId] = val
  }

  return value
}


export function isMuiltLanguagesJson(value){
  var res = false
  if(value && value.hasOwnProperty('muiltLanguagesJson')){
    res = true
  }
  return res
}

export function createMuiltLanguagesJson(value, opts = undefined){
  if (isMuiltLanguagesJson(value)) {
    value = value.default
  }
  var res = {
    muiltLanguagesJson: true,
    'default': value
  }
  if(opts){
    for(var key in opts){
      res[key] = opts[key]
      if (isMuiltLanguagesJson(opts[key])) {
        res[key] = opts[key].default
      } else {
        res[key] = opts[key]
      }
    }
  }

  return res
}

export function isOkValueOfMuiltLanguagesJson(value){
  return typeof value === 'object' && isMuiltLanguagesJson(value)
}
